import axios from ".";
import queryString from "query-string";
import {
  ChannelStatus,
  FetchLiveChannelsQueryType,
} from "../../../helpers/constants/streaming";

export default {
  createChannel,
  isLiveChannel,
  isEndedChannel,
  findChannelById,
  isOfflineChannel,
  findLiveStreamingChannels,
  findLivePerformers
};

function isLiveChannel(channel) {
  return channel.status === ChannelStatus.Live;
}

function isEndedChannel(channel) {
  return channel.status === ChannelStatus.Ended;
}

function isOfflineChannel(channel) {
  return channel.status === ChannelStatus.Offline;
}

async function createChannel(
  name,
  showCollectedTip,
  isCameraOff,
  isMuted,
  isChatDisabled
) {
  const response = await axios.post("/api/channels", {
    name,
    showCollectedTip,
    isCameraOff,
    isMuted,
    isChatDisabled,
  });

  return response.data;
}

async function findChannelById(channelId) {
  const response = await axios.get(`/api/channels/${channelId}/withMessages`);
  return response.data;
}

async function findLiveStreamingChannels(
  type = FetchLiveChannelsQueryType.All,
  q = "",
  page = 1,
  cancelToken = null
) {
  const params = queryString.stringify({ q, type, page });
  const response = await axios.get(`/api/channels/live?${params}`, {
    cancelToken,
  });
  return response.data;
}

async function findLivePerformers(
  type = FetchLiveChannelsQueryType.All,
  q = "",
  page = 1,
  cancelToken = null
) {
  const params = queryString.stringify({ q, type, page });
  const response = await axios.get(`/api/users/performers?${params}`, {
    cancelToken,
  });
  return response.data;
}
